import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { BreadcrumbItemProps } from './types';
import { capitalizeWords } from '@src/utils';
import { useAppSelector } from '@store/hooks';
import { selectGlobal } from '@store/slices/global/global';

const BreadcrumbItem = memo(
  ({ item, isLast, showDivider }: BreadcrumbItemProps) => {
    const { currentPath } = useAppSelector(selectGlobal);

    const isHome = item.id === 'home';
    const isReportLink = currentPath === 'reporting';

    const isClickable = !isLast && (item.clickable || isHome || isReportLink);
    const title = item.preserveTitle
      ? item.title
      : capitalizeWords(item.title.toLowerCase());

    return (
      <>
        <li
          className={isLast ? 'active' : ''}
          data-test-id={`bc-${item.id}`}
          title={title}
        >
          {isClickable ? (
            <Link
              to={item.path}
              style={{ color: 'inherit' }}
              data-test-id={`bc-link-${item.id}`}
            >
              {title}
            </Link>
          ) : (
            <span data-test-id={`bc-txt-${item.id}`}>{title}</span>
          )}
        </li>

        {showDivider && (
          <li className="divider" data-test-id="bc-div">
            /
          </li>
        )}
      </>
    );
  }
);

BreadcrumbItem.displayName = 'BreadcrumbItem';

export default BreadcrumbItem;
